import { Button } from "@mui/material";
import { DEFAULT_FORM_ID } from "constants";
import cn from "classnames";
export const BrandButton = ({
  formId = DEFAULT_FORM_ID,
  variant = "contained",
  children,
  isDisabled,
  type,
  isLoading,
  className,
  ...props
}) => {
  return (
    <Button
      type={type}
      loading={isLoading}
      {...(type === "submit" && { form: formId })}
      variant={variant}
      disabled={isDisabled}
      className={cn("brand-button", className)}
      {...props}
    >
      {children}
    </Button>
  );
};
